import type { ButtonHTMLAttributes } from "react";
import { eyeIcon } from "../../../../icons/eyeIcon";

interface ViewButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "title"
> {
  onClick: () => void;
  title?: string;
}

export const ViewButton = ({
  onClick,
  title,
  className = "",
  ...buttonProps
}: ViewButtonProps) => {
  const displayTitle = title ?? "";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`p-1.5 text-global-accent hover:text-global-title-accent hover:bg-global-accent-overlay rounded-md transition-all ${className}`.trim()}
      title={displayTitle}
      {...buttonProps}
    >
      {eyeIcon}
    </button>
  );
};
